import { AuthVerified, AuthTransfer } from "../../models/generic/auth-transfer";
import { IBaseState } from "..";
import { INavbar } from "../../models/app-configuration";
import {
    LOCALSTORAGE_MAP_OPTIONS,
    LOCALSTORAGE_MAP_REGIONS,
    WEBAPP_LAYOUT
} from "../../common/constants";
import { IPersonAutoComplete } from "../../models/autocomplete";
import {
    IGridConfiguration
} from "../../models/common/grid-config.model";
import { IBasePositiveAndNegative } from "../../models/common/AgendaCommon";
import { IRouteTab } from "../../models/common/route-tab.model";
import { IConsultedPerson } from "../../models/person/consulted-person.model";
import { IRouterHelper } from "../../models/router";
import { IMessageNotificationParameterModel, MessageNotificationParameter } from "../../models/message-notification/index";
import { QuickViewPropsModel, OpenAppointmentPropsModel } from "../types";
import { AgendPrefetchInfo } from "../../models/agenda";
import { IDrawerModel } from "../../models/common/drawer.model";
import { IUploadCommon } from "../../models/common/upload-file-model";

export interface ICommonState extends IBaseState<{}, {}> {
    isOpenModal?: boolean;
    isHorizontalPage: boolean;
    navbar?: INavbar;
    userSession?: AuthVerified | null;
    authTransfer?: AuthTransfer;
    listOfPlaces?: string[];
    previousQuery?: string;
    listOfPeople?: IPersonAutoComplete[];
    previousQueryPeople?: string;
    mapOptions?: any;
    mapRegions?: any;
    prevTypeOfPropertyId?: number;

    gridConfigsProperties?: IGridConfiguration;
    gridConfigsPersons?: IGridConfiguration;
    gridConfigsDemands?: IGridConfiguration;
    gridConfigsTasks?: IGridConfiguration;
    loading?: boolean;
    streaming?: boolean;
    positive?: IBasePositiveAndNegative[];
    negative?: IBasePositiveAndNegative[];
    visitedViews?: IRouteTab[];
    consultedNextPerson?: IConsultedPerson[];
    gridConfigsUsedUsers?: object;

    // router helper state
    routeLevel?: number;
    routerList?: IRouterHelper[];

    // message-notification filter;
    filterMessageNotification?: IMessageNotificationParameterModel;

    // message-notification mark read;
    markReadMessageNotificationIds?: number[];

    //send message, print modal
    sendMessageModalVisible?: boolean;
    printTemplateModalVisible?: boolean;
    printTemplateModalProps?: any;
    sendMessageModalProps?: any;
    sendSMSModalProps?: any;
    sendSMSModalVisible?: boolean;

    //large mailing
    largeMailingModalVisible?: boolean;

    // quick view right content
    quickViewObjectProps?: QuickViewPropsModel;

    // notification message
    notificationMessage?: any

    // conflict data
    conflictDataInfoVisible?: any
    userChangeDataFields?: Array<string>

    //drawer
    drawerModels?: IDrawerModel[];

    personMergeDataTemp?: {
        originId: number,
        data: object,
        destinationId: number
    };

    openAppointmentModalProps?: OpenAppointmentPropsModel;
    agendaPrefetchInfo?: AgendPrefetchInfo;

    webappLayoutMode?: string;
    // True once the Enquiry webview has initialised, so the global back-bar only appears
    // for the Enquiry flow and not for other webviews (AI image, document, etc.).
    isEnquiryWebviewSession?: boolean;

    //upload common
    uploadModels?: IUploadCommon[];

}

export class CommonState implements ICommonState {
    isOpenModal: boolean;
    isHorizontalPage: boolean;
    isPageRendered?: boolean;
    service?: {};
    searchParam?: {};
    navbar?: INavbar;
    userSession?: AuthVerified | null;
    authTransfer?: AuthTransfer;
    listOfPlaces?: string[];
    previousQuery?: string;
    listOfPeople?: IPersonAutoComplete[];
    previousQueryPeople?: string;
    mapOptions: any;
    mapRegions: any;
    prevTypeOfPropertyId: number;

    gridConfigsProperties?: IGridConfiguration;
    gridConfigsPersons?: IGridConfiguration;
    gridConfigsDemands?: IGridConfiguration;
    gridConfigsTasks?: IGridConfiguration;
    loading?: boolean;
    streaming?: boolean;
    positive?: IBasePositiveAndNegative[];
    negative?: IBasePositiveAndNegative[];
    visitedViews?: IRouteTab[];
    consultedNextPerson?: IConsultedPerson[];

    // router helper state
    routeLevel?: number;
    routerList?: IRouterHelper[];

    // message-notification filter;
    filterMessageNotification?: IMessageNotificationParameterModel;

    sendMessageModalVisible?: boolean;
    printTemplateModalVisible?: boolean;
    printTemplateModalProps?: any = {};
    sendMessageModalProps?: any = {};
    quickViewObjectProps?: QuickViewPropsModel = null;
    gridConfigsUsedUsers?: object;

    //large mailing
    largeMailingModalVisible?: boolean;

    drawerModels?: IDrawerModel[];

    notificationMessage?: any
    personMergeDataTemp?: {
        originId: number,
        data: object,
        destinationId: number
    };

    openAppointmentModalProps?: OpenAppointmentPropsModel = null;

    agendaPrefetchInfo?: AgendPrefetchInfo;

    webappLayoutMode?: string;
    isEnquiryWebviewSession?: boolean;
    conflictDataInfoVisible?: any;
    userChangeDataFields?: Array<string>

    //upload common
    uploadModels?: IUploadCommon[];
	/**
	 *
	 */
    constructor(options: ICommonState) {
        this.isOpenModal = false;
        this.navbar = options.navbar === undefined ? null : options.navbar;
        this.userSession = null;
        this.authTransfer = null;
        this.isHorizontalPage = options.isHorizontalPage;
        this.isPageRendered = options.isPageRendered && this.userSession !== null;
        this.service = options.service;
        this.searchParam = options.searchParam;
        this.listOfPlaces = [];
        this.listOfPeople = [];
        this.mapOptions = localStorage.getItem(LOCALSTORAGE_MAP_OPTIONS);
        this.mapRegions = localStorage.getItem(LOCALSTORAGE_MAP_REGIONS);
        this.prevTypeOfPropertyId = undefined;
        this.gridConfigsProperties = null;
        this.gridConfigsPersons = null;
        this.gridConfigsDemands = null;
        this.gridConfigsTasks = null;
        this.loading = options.loading || false;
        this.streaming = options.streaming || false;
        this.positive = options.positive || [];
        this.negative = options.negative || [];
        this.visitedViews = options.visitedViews || [];
        this.consultedNextPerson = options.consultedNextPerson || [];
        this.routeLevel = options.routeLevel || 0;
        this.routerList = options.routerList || [];
        this.filterMessageNotification = new MessageNotificationParameter();
        this.sendMessageModalVisible = options.sendMessageModalVisible || false;
        this.largeMailingModalVisible = options.largeMailingModalVisible || false;
        this.printTemplateModalVisible = options.printTemplateModalVisible || false;
        this.conflictDataInfoVisible = options.conflictDataInfoVisible || null;
        this.userChangeDataFields = options.userChangeDataFields || [];
        this.gridConfigsUsedUsers = options.gridConfigsUsedUsers || {};
        this.notificationMessage = options.notificationMessage || null;
        this.agendaPrefetchInfo = {
            managerInfo: {},
            personInfo: null,
            propertyInfo: null,
            taskId: null,
            taskUserId: null
        };
        this.webappLayoutMode = WEBAPP_LAYOUT.DEFAULT;
        this.isEnquiryWebviewSession = false;
        this.drawerModels = options.drawerModels || [];
        this.uploadModels = options.uploadModels || [];
        this.personMergeDataTemp = null;
    }
}
